import React, { useState } from 'react'
import Box from '@mui/material/Box';
import { AiOutlinePlus } from "react-icons/ai"
import Modal from '@mui/material/Modal';
import arrow from "../assets/larrow.png"
import { Daysarray } from '../profile/Directoriesarray';


function Schedulemodal() {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        // background: "rgba(0, 0, 0, 0.2)",
        backdropFilter: "blur(2.5px)",
        border: "none",
        boxShadow: 24,
        borderRadius: "10px",

    }
    return (<>
        <div>

            <button onClick={handleOpen} style={{ paddingLeft: "15px", paddingRight: "15px" }} className='connect_btn ad_btn business_add d-flex  justify-content-center'>
                <div className='d-flex gap-2 justify-content-center align-items-center'>
                    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.8333 10.8333H15.1667V2.1667C15.1667 0.970699 14.1982 0 13 0C11.8018 0 10.8333 0.970699 10.8333 2.1667V10.8333H2.1667C0.968515 10.8333 0 11.804 0 13C0 14.196 0.968515 15.1667 2.1667 15.1667H10.8333V23.8333C10.8333 25.0293 11.8018 26 13 26C14.1982 26 15.1667 25.0293 15.1667 23.8333V15.1667H23.8333C25.0315 15.1667 26 14.196 26 13C26 11.804 25.0315 10.8333 23.8333 10.8333Z" fill="white" />
                    </svg>

                    <p className='schedule_btn_text'>Schedule Post</p>
                </div>

            </button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box className="d-flex align-items-center ps-2 pt-2 pb-2">
                        <img src={arrow} onClick={handleClose} />
                        <p className='text-center w-100 modal_header_text'>Update Timeslot</p>
                    </Box>
                    <Box className="d-flex gap-1 justify-content-between flex-wrap ps-2 pe-2 pt-4" style={{ borderTop: "1px solid rgba(188, 188, 188, 0.3)" }}>
                        {Daysarray.map((e) => {
                            return (
                                <div className='modal_day_div'>
                                    <p>{e.day}</p>
                                </div>
                            )
                        })}
                    </Box>
                    <Box className="d-flex gap-2 justify-content-between flex-wrap ps-2 pe-2 pt-5 w-100">
                        <div className='modal_time '>
                            <p>10       :      00      AM</p>
                        </div>
                        <div className='modal_time ps-2 pe-2 '>
                            <p>10       :      00      AM</p>
                        </div>
                    </Box>
                    <Box className="ps-2 pe-2 pt-5 pb-2 d-flex justify-content-between gap-2 flex-wrap">
                        <button className='schedule_modal_cancel'>Cancel</button>
                        <button className='schedule_modal_update'>Update</button>
                    </Box>


                </Box>
            </Modal>
        </div>

    </>

    )
}

export default Schedulemodal